module.exports = __webpack_public_path__ + "media/img/security-illustration-ee8d136d5fd2ea7bbd10f059c2992539.svg";